type SkeletonTextSize =
    | 'xxsmall'
    | 'xsmall'
    | 'small'
    | 'medium'
    | 'large'
    | 'xlarge'

type SkeletonTextProps = {
    size?: SkeletonTextSize
}

const sizeClassnameMap: Record<SkeletonTextSize, string> = {
    xxsmall: 'w-8',
    xsmall: 'w-16',
    small: 'w-24',
    medium: 'w-32',
    large: 'w-40',
    xlarge: 'w-48',
}

export const SkeletonText: React.FC<SkeletonTextProps> = ({
    size = 'medium',
}) => {
    const sizeClassname = sizeClassnameMap[size]

    return (
        <div
            className={`rounded-md inline-block text-[80%] ${sizeClassname} animate-[pulse_1s_ease-in-out_infinite] bg-neutral-100 text-[transparent]`}
        >
            &nbsp;
        </div>
    )
}
